import { useRouteMatch, Switch, Route } from "react-router";
import PostcodeChecker, { PostcodeCheckerData } from "./PostcodeChecker";
import PostcodeIneligibleScreen from "./PostcodeIneligibleScreen";
import PostcodeEligibleScreen from "./PostcodeEligibleScreen";
import NoPlacesAvailableScreen from "./NoPlacesAvailableScreen";
import { programmes } from "../../../../enums/programmes";
import NoReturnScreen from "./NoReturnScreen";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

export interface PostcodeCheckerRootProps {
  postcodePageData: PostcodeCheckerData;
  nextStepUrl: string;
  programmeTitle: string;
  programmeId: string;
  existingPostcode: string | null;
  progressPercentage?: PowerOfTen;
}

const PostcodeCheckerRoot = (props: PostcodeCheckerRootProps) => {
  const { postcodePageData, nextStepUrl, programmeTitle, programmeId, existingPostcode, progressPercentage } =
    props;

  let { path } = useRouteMatch();
  const ineligiblePostcode = postcodePageData.ineligibleScreens.ineligiblePostcode;
  const noSpacesAvailable = postcodePageData.ineligibleScreens.noSpacesAvailable;
  const noReturnPeriod = postcodePageData.ineligibleScreens.noReturnPeriod;

  const dispatch = useDispatch();

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  return (
    <Switch>
      <Route path={`${path}/success`}>
        <PostcodeEligibleScreen postcodePageData={postcodePageData} nextStepUrl={nextStepUrl} />
      </Route>
      <Route exact path={path}>
        <PostcodeChecker
          postcodePageData={postcodePageData}
          programmeTitle={programmeTitle}
          programmeId={programmeId}
          existingPostcode={existingPostcode}
        />
      </Route>
      <Route path={`${path}/fail`}>
        <PostcodeIneligibleScreen
          title={ineligiblePostcode.title}
          heading={ineligiblePostcode.heading}
          body={ineligiblePostcode.body}
        />
      </Route>
      <Route path={`${path}/no-places-available`}>
        <NoPlacesAvailableScreen
          title={noSpacesAvailable.title}
          heading={noSpacesAvailable.heading}
          body={noSpacesAvailable.body}
        />
      </Route>
      {programmeId === programmes["lose-weight"].id && (
        <Route path={`${path}/no-return-period/:eligibleReturnDate`}>
          <NoReturnScreen
            title={noReturnPeriod.title}
            heading={noReturnPeriod.heading}
            body={noReturnPeriod.body}
          />
          ;
        </Route>
      )}
    </Switch>
  );
};

export default PostcodeCheckerRoot;
